import { SelectedLineResil } from '../../models/selected-line';

// @ts-ignore
export const reponseSelection: SelectedLineResil = {
    cogeree: false,
    geree: false,
    tiers: false,
    profilPSW: "INTERNET_RESILIE",
    facturationData: {
        idFoncCompteClient: "99-NW96GA",
        idFoncCompteFacturation: "1-4FWSRP5F",
        idFoncPersonne: null
    },
    titulaireData: {
        emailDeContact: "stephane.foin@sfr.com",
        nom: "null",
        prenom: "null"
    },
    ndi: "1-4FWSRP5F",
    crmid: "1-4FWSRP5F",
    numeroSiOffre: "1CZB6K",
    optionsSouscrites: [],
    numero: "1-4FWSRP5F",
    mobile: false,
    red: false,
    pro: false,
    home: false
}

export const reponseSelectionResilie: SelectedLineResil = {
    cogeree: false,
    geree: false,
    tiers: false,
    profilPSW: 'MOBILE_RESILIE',
    facturationData: {
        idFoncCompteClient: '99-NXWTZI',
        idFoncCompteFacturation: '99-NXWTZI-01',
        idFoncPersonne: null
    },
    titulaireData: {
        emailDeContact: 'aliceb2002@live.fr',
        nom: 'BONIN RUIZ',
        prenom: 'ALICE'
    },
    msisdn: null,
    segment: '09',
    resilieData: {
        numeroContrat: '09-R6IFQ9',
        gammeTarifaire: null,
        msisdn: null,
        profilPSW: 'MOBILE_ABONNE_RED'
    },
    numeroContrat: 'R6IFQ9',
    numeroSiOffre: 'R6IFQ9',
    codePlanTarifaire: 'BX2',
    libellePlanTarifaire: 'RED Box 5G',
    box4G: true,
    dateResilEnregistre: '2026/Jun/13 22:00:00 +0000',
    dateResilProgramme: '2026/Jun/13 22:00:00 +0000',
    motifResil: 'MT089',
    statutSecondaire: null,
    utilisateurData: null,
    dateFinPeriodeContractuelle: '2024/Aug/21 22:00:00 +0000',
    msisdnWithoutZero: null,
    codeCSU: '09-R6IFQ9',
    numero: '09-R6IFQ9',
    mobile: true,
    red: false,
    home: false,
    pro: false
}

